var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.715,
    height: 13.028,
    fill: "none",
    viewBox: "0 0 15.715 13.028",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.708 1.1262c-0.219 2.2914-1.1574 7.844-1.6423 10.409-0.2033 1.0871-0.6022 1.4468-0.9854 1.4859-0.8368 0.0783-1.4781-0.5552-2.2914-1.087-1.2748-0.8368-1.9943-1.353-3.2299-2.1663-1.4312-0.93849-0.50051-1.4625 0.31283-2.3071 0.21115-0.21898 3.9181-3.5896 3.9885-3.8946 0.0078-0.03911 0.0156-0.17988-0.0704-0.25808-0.086-0.07821-0.2112-0.04693-0.2972-0.03129-0.1251 0.03129-2.1585 1.3764-6.1 4.0354-0.57872 0.39885-1.1027 0.58654-1.5719 0.57872-0.51615-0.00782-1.5094-0.28936-2.2523-0.5318-0.90718-0.29718-1.6267-0.45359-1.5641-0.95411 0.031282-0.25808 0.39103-0.52398 1.0792-0.7977 4.2153-1.8378 7.0307-3.05 8.4384-3.6366 4.0198-1.6736 4.8566-1.963 5.3962-1.9708 0.1173 0 0.3832 0.031281 0.5631 0.16423 0.1173 0.10167 0.1877 0.24244 0.2033 0.39103 0.0313 0.18769 0.0392 0.38321 0.0235 0.5709z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTelegram);
export default __webpack_public_path__ + "static/media/icn-telegram.df3f245530d0ec0eb78cc1d838016049.svg";
export { ForwardRef as ReactComponent };